import {buildConfigUrl, buildFormRenderContext, FormLoaderError, PAGE_TYPE_FORM} from '@bff/loader-utils';
import {loadConfig} from './loadConfig';
import {mountForm} from './mountForm';
import type {Environment, EventHandlers, PageType, Protocol} from '../types';

interface LoadAndMountFormParams {
    container?: HTMLElement;
    network: string;
    property: string;
    pageId: string;
    pageType?: PageType;
    isPreview?: boolean;
    viewClone?: boolean;
    env?: Environment;
    protocol?: Protocol;
    bootstrapOnly?: boolean;
    setPageTitle?: boolean;

    eventHandlers?: EventHandlers;
}

const ERROR_HTML =
    '<h2>Form Not Found</h2>' +
    '<p>We are sorry, but you have reached this page in error. Please try the action' +
    ' again and if the problem continues contact Customer Service.</p>';

function originAndPath(url: string): string {
    const u = new URL(url, window.location.origin);
    return u.origin + u.pathname;
}

export async function loadAndMountForm(loadAndRenderFormParams: LoadAndMountFormParams) {
    let formRenderContext;
    try {
        // 400
        const configUrl = buildConfigUrl({
            // required
            network: loadAndRenderFormParams.network,
            property: loadAndRenderFormParams.property,
            pageId: loadAndRenderFormParams.pageId,
            // optional
            viewClone: loadAndRenderFormParams.viewClone,
            protocol: loadAndRenderFormParams.protocol,
            env: loadAndRenderFormParams.env
        });
        // 404, 500
        const formConfig = await loadConfig(configUrl);
        // 301, 400, 404, 500
        formRenderContext = buildFormRenderContext(formConfig, loadAndRenderFormParams.pageType || PAGE_TYPE_FORM, loadAndRenderFormParams.isPreview || false);
    } catch (error) {
        if (error instanceof FormLoaderError && error.status === 301 && error.redirectUrl && originAndPath(document.location.href) !== originAndPath(error.redirectUrl)) {
            document.location.href = error.redirectUrl;
        } else if (loadAndRenderFormParams.container) {
            loadAndRenderFormParams.container.innerHTML = ERROR_HTML;
            return;
        }
        throw new FormLoaderError('Failed to load or mount form', 500);
    }
    await mountForm({
        jsUrl: formRenderContext.jsUrl,
        cssUrl: formRenderContext.cssUrl,
        bootstrapOnly: loadAndRenderFormParams.bootstrapOnly || false,
        pageTitle: loadAndRenderFormParams.setPageTitle ? formRenderContext.pageTitle : undefined
    });
}
